/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1.0
 */

export type InstanceStatus = typeof InstanceStatus[keyof typeof InstanceStatus];


export const InstanceStatus = {
  Open: 'Open',
  CompletedByEmployeeUser: 'CompletedByEmployeeUser',
  CompletedByCompanyManagementUser: 'CompletedByCompanyManagementUser',
  ClosedBySystem: 'ClosedBySystem',
  Completed: 'Completed',
  Closed: 'Closed',
  Orphaned: 'Orphaned',
} as const;
